import { render } from "./VascularTableView.vue?vue&type=template&id=07fea157"
import script from "./VascularTableView.vue?vue&type=script&lang=js"
export * from "./VascularTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__